//Assemblies statistics
// Select all statistics boxes
const boxes = document.querySelectorAll('.statistic__container > .statistic');

// Find the maximum width of the boxes
let maxWidth = 0;

/**
 * handleBoxSizing()
 * Description: A function to address the issue of metric titles being trimmed on the 'About this panel'
 *              page, ensuring they are fully displayed. It adjusts the statistics boxes to have a uniform
 *              width, matching the width of the largest box.
 * Returns: void
 */
const handleBoxSizing = () => {
    boxes.forEach(box => {
        let width = box.offsetWidth;
        if (width > maxWidth) {
            maxWidth = width;
        }
    });

    // Apply the maximum width to all boxes
    boxes.forEach(box => {
        box.style.width = `${maxWidth}px`;
    });
}

addEventListener("load", handleBoxSizing );
addEventListener("resize", handleBoxSizing );